export const USER_ROLES = ["ADMIN", "AGENT", "WORKER", "SUPERVISOR", "CODEX"];

export const USER_ROLE_BADGE_VARIANTS = {
    ADMIN: "danger",
    AGENT: "primary",
    WORKER: "success",
    SUPERVISOR: "warning",
    CODEX: "dark",
};
